<div class="main-container"></div>

<section class="dialog-section">
  <div class="dialog-container">
    <div class="dialog-card">
      <!-- Loading -->
      <div *ngIf="isLoading" class="loading-container">
        <mat-spinner></mat-spinner>
      </div>

      <!-- Content -->
      <div class="dialog-content" *ngIf="!isLoading && consent">
        <!-- With short description and no content : show short description -->
        <ng-container *ngIf="consent.description && !consent.content">
          <p>{{ consent.description }}</p>
        </ng-container>

        <!-- Without short description -->
        <div *ngIf="consent.content" [innerHTML]="consent.content | safe: 'html'"></div>
      </div>

      <!-- Actions -->
      <div class="dialog-actions">
        <button class="primary-button" (click)="accept()" [disabled]="isLoading">
          {{ "button.accept" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
